<template>
  <div class="main-w pageination-container" data-aos="fade-up">
    <div class="other" @click="turnPage('/')">首页</div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="  prev, pager, next"
        :total="400"
      >
      </el-pagination>
    </div>
    <div class="other">末页</div>
    <div class="other total">总页数:{{ total }}</div>
    <div class="jumper">
      <el-input></el-input>
    </div>
    <div class="jumper-btn">确定</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      total: 100
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    turnPage(path) {
      this.$router.push(path)
    }
  }
}
</script>
<style lang="scss" scoped>
.pageination-container {
  padding: 39px 0 79px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 27px;
  height: 14px;

  .other {
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    flex-shrink: 0;
    cursor: pointer;
  }
  .page {
    margin-left: 13px;
  }
  .total {
    margin-left: 23px;
    margin-right: 21px;
  }
  .jumper {
    margin-right: 17px;
    ::v-deep .el-input__inner {
      width: 67px;
      height: 25px;
      border: 1px solid #999999;
      border-radius: 5px;
      text-align: center;
    }
  }
  .jumper-btn {
    flex-shrink: 0;
    width: 45px;
    height: 24px;
    background: #c6a669;
    border-radius: 5px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
  }
}
</style>